export const getDomainSuffix = (url: string) => url.split('.').pop()
